// extracted by mini-css-extract-plugin
module.exports = {"box":"role_box_2ptuv","question":"role_question_Z5VXm","bind":"role_bind_1fzMo","field":"role_field_1KSbV","sure":"role_sure_3JgFF","remove":"role_remove_1QLdq"};